var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"},attrs:{"id":"LoadingComId"}},[_c('van-overlay',{attrs:{"show":true}},[_c('van-loading',{staticStyle:{"margin-top":"60%","color":"red"},attrs:{"color":"red","size":"30px","vertical":""}},[_c('span',{staticStyle:{"color":"red"}},[_vm._v("加载中...")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15191076","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commonCom/LoadingCom.vue
// module id = null
// module chunks = 